<div [ngClass]="isEditable() ? 'inner-cell' : 'inner-cell-not-editable'">
  <div class="inner-cell-lookup-value">{{params.value}}</div>
  <button mat-icon-button (click)="openDialog($event)" *ngIf="isEditable()">
    <mat-icon>search</mat-icon>
  </button>
</div>
